import { Button } from './ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function TablePagination({ page, totalPages, total, limit, onPageChange }) {
  if (totalPages <= 1) return null;

  const pages = [];
  const maxVisible = 5;
  let start = Math.max(1, page - Math.floor(maxVisible / 2));
  let end = Math.min(totalPages, start + maxVisible - 1);
  if (end - start + 1 < maxVisible) start = Math.max(1, end - maxVisible + 1);

  for (let i = start; i <= end; i++) pages.push(i);

  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-[#DFDEDE]" data-testid="table-pagination">
      <p className="text-xs text-[#A6A2A0]">
        {((page - 1) * limit) + 1}–{Math.min(page * limit, total)} dari {total}
      </p>
      <div className="flex items-center gap-1">
        <Button variant="ghost" size="sm" disabled={page <= 1} onClick={() => onPageChange(page - 1)} data-testid="pagination-prev">
          <ChevronLeft size={16} />
        </Button>
        {start > 1 && (
          <>
            <Button variant="ghost" size="sm" onClick={() => onPageChange(1)} className="w-8 h-8 p-0 text-xs text-[#64584F]">1</Button>
            {start > 2 && <span className="text-[#A6A2A0] text-xs px-1">...</span>}
          </>
        )}
        {pages.map(p => (
          <Button
            key={p} variant={p === page ? "default" : "ghost"} size="sm"
            onClick={() => onPageChange(p)}
            className={`w-8 h-8 p-0 text-xs ${p === page ? 'bg-[#EB7B44] hover:bg-[#D96A35] text-white' : 'text-[#64584F]'}`}
            data-testid={`pagination-page-${p}`}
          >
            {p}
          </Button>
        ))}
        {end < totalPages && (
          <>
            {end < totalPages - 1 && <span className="text-[#A6A2A0] text-xs px-1">...</span>}
            <Button variant="ghost" size="sm" onClick={() => onPageChange(totalPages)} className="w-8 h-8 p-0 text-xs text-[#64584F]">{totalPages}</Button>
          </>
        )}
        <Button variant="ghost" size="sm" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)} data-testid="pagination-next">
          <ChevronRight size={16} />
        </Button>
      </div>
    </div>
  );
}
